import { noty } from './noty';
import { button } from './button';
import { modal } from './modal';
import { select } from './select';
import { table } from './table';
import { filter } from './filter';
import { sms_input } from './sms-input';
import { file_upload } from './file-upload';
import { export_report } from './export-report';
import { recipient_form } from './recipient-form';

export const component = {
  noty,
  button,
  modal,
  select,
  table,
  filter,
  sms_input,
  file_upload,
  recipient_form,
  export_report,

  ['v-copy']: {
    copy: 'Copy to clipboard'
  }
};
